import React from "react";

const fmt = (at) => new Date(at).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" });

export default function HistoryStamps({ history, fallbackAction, fallbackName, fallbackAt, testid = "history-stamps" }) {
  const list = history?.length
    ? history
    : fallbackName ? [{ action: fallbackAction, by: fallbackName, at: fallbackAt }] : [];
  if (!list.length) return null;
  return (
    <ul className="text-[11px] text-muted-foreground space-y-0.5 border-t border-border pt-2 mt-2" data-testid={testid}>
      {list.map((h, i) => (
        <li key={i} className="flex flex-wrap gap-x-1" data-testid={`${testid}-entry`}>
          <span className="font-semibold text-foreground/80">{h.action}</span>
          <span>by {h.by}</span>
          {h.at && <span>· {fmt(h.at)}</span>}
        </li>
      ))}
    </ul>
  );
}
